const logger = console.scope('latency')

let regionOrder = null

async function testLatency(url) {
	const start = performance.now()
	try {
		await fetch(url, { method: 'GET', mode: 'no-cors' })
		return performance.now() - start
	} catch {
		return null
	}
}

async function measureRegionLatencies(regions) {
	if (!regions?.length) return []

	logger.info(`Testing latency for ${regions.length} regions...`)

	const results = await Promise.all(
		regions.map(async ({ name, headEndpoint }) => {
			const latency = await testLatency(headEndpoint)
			return { name, latency }
		})
	)

	const sorted = results
		.filter(r => r.latency !== null)
		.sort((a, b) => a.latency - b.latency)
		.map(r => r.name)

	logger.info('Region order:', sorted, results.map(r => `${r.name}: ${r.latency?.toFixed(0)}ms`).join(', '))

	regionOrder = sorted
	return sorted
}

function getRegionOrder() {
	return regionOrder
}

export { measureRegionLatencies, getRegionOrder }
export default { measureRegionLatencies, getRegionOrder }
